import React from "react";
import PropTypes from "prop-types";
import Button from "react-bootstrap/Button";
import { useCallback } from "react";

const FormCustom = ({
  onSubmit,
  dataSubmit,
  children,
  viewSubmit,
  disablebSubmit,
  textButton,
  className,
  loadSubmit,
  beforeSubmit,
  hiddenBtn,
  primary,
  bg,
  onClickTime,
}) => {
  const handleSubmit = useCallback(
    (e) => {
      e.preventDefault();
      let dataForm = {};

      let hasError = false;
      let f = e?.target?.elements;
      if (f?.length > 0) {
        for (let i = 0; i < f?.length; i++) {
          let ele = f[i];

          if (!ele?.name) {
            continue;
          }

          if (!ele?.validity?.valid) {
            ele?.focus();
            hasError = true;
            break;
          }

          if (ele?.tagName === "INPUT") {
            if (ele?.name.includes("[]")) {
              if (ele?.checked) {
                if (!dataForm[ele?.name.replace("[]", "")]) {
                  dataForm[ele?.name.replace("[]", "")] = [ele?.value];
                } else {
                  dataForm[ele?.name.replace("[]", "")].push(ele?.value);
                }
              }
              continue;
            }

            /* if (ele?.value !== ele?.value.trim()) {
          ele?.focus()
          hasError = true
          break
        } */

            if (!dataForm[ele?.name]) {
              dataForm[ele?.name] = ele?.value;
            }
          } else if (ele?.tagName === "TEXTAREA") {
            if (ele?.value !== ele?.value.trim()) {
              ele?.focus();
              hasError = true;
              break;
            }
            if (!dataForm[ele?.name]) {
              dataForm[ele?.name] = ele?.value;
            }
          } else if (ele?.tagName === "SELECT") {
            if (!dataForm[ele?.name]) {
              dataForm[ele?.name] = ele?.value;
            }
          }
        }

        if (!e.target.checkValidity() || hasError) {
          beforeSubmit();
          e.target.classList.add("was-validated");
          return;
        }

        e?.target?.classList?.remove("was-validated");

        onSubmit({ e, data: dataSubmit });
      }
    },
    [onSubmit, dataSubmit, beforeSubmit]
  );

  return (
    <form
      className={"needs-validation form-row " + className}
      noValidate
      onSubmit={(e) => {
        e.preventDefault();
        if (!loadSubmit) {
          handleSubmit(e);
        }
      }}
      autoComplete="off"
      style={{ backgroundColor: bg || "transparent" }}
    >
      {children}
      {viewSubmit && !hiddenBtn ? (
        <div className="col-12" style={{ display: "flex" }}>
          <Button
            variant={primary ? "primary" : "success"}
            disabled={disablebSubmit}
            className={`mt-2 ${onClickTime ? "col-11" : "col-12"}`}
            size="sm"
            block
            type="submit"
          >
            {loadSubmit ? (
              <i className="fa fa-circle-notch fa-spin"></i>
            ) : (
              <>
                <i className="fa fa-check mr-2"></i> {textButton}
              </>
            )}
          </Button>
          {onClickTime && (
            <Button
              variant={primary ? "primary" : "success"}
              onClick={onClickTime}
              className="mt-2 col-1 ml-1"
              size="sm"
              block
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="currentColor"
                className="bi bi-clock"
                viewBox="0 0 16 16"
              >
                <path d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z" />
                <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0z" />
              </svg>
            </Button>
          )}
        </div>
      ) : (
        ""
      )}
    </form>
  );
};
FormCustom.defaultProps = {
  onSubmit: () => {},
  viewSubmit: true,
  data: [],
  disablebSubmit: false,
  textButton: "Guardar Información",
  className: "",
  loadSubmit: false,
  beforeSubmit: () => {},
};
FormCustom.propTypes = {
  onSubmit: PropTypes.func,
  viewSubmit: PropTypes.bool,
  data: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  disablebSubmit: PropTypes.bool,
  loadSubmit: PropTypes.bool,
};

export default FormCustom;
